import { instance } from './axios.instance'
import { INVENTORY_ENDPOINT } from './endpoints'

/**
 * 자산 상세
 * GET /api/tools/{id}
 * @param {string} id
 */
export const getToolsInventoryDetail = id => instance.get(INVENTORY_ENDPOINT.DETAIL(id))

/**
 * 자산 삭제
 * DELETE /api/tools/{id}
 * @param {string} id
 */
export const deleteToolInventory = id => instance.delete(INVENTORY_ENDPOINT.DELETE(id))

/**
 * 자산 수정
 * PATCH /api/tools/{id}
 * @param {string} id
 * @param {Object} data
 */
export const editToolsInventory = (id, data) => instance.patch(INVENTORY_ENDPOINT.EDIT(id), data)

/**
 * 자산 등록
 * POST /api/tools/create
 * @param {Object} data
 */
export const createToolsInventory = data => instance.post(INVENTORY_ENDPOINT.CREATE, data)

/**
 * 자산 목록
 * GET /api/tools/list
 * @param {Object} params
 */
export const getToolsInventoryList = params => instance.get(INVENTORY_ENDPOINT.LIST, { params })

/**
 * 자산 번호 유효성 체크
 * POST /api/tools/confirm
 * @param {Object} data
 */
export const getToolsConfirm = data => instance.post(INVENTORY_ENDPOINT.CONFIRM, data)
